import React from 'react';
import ZeroStar from './Icons/0star.png';
import OneStar from './Icons/1star.png';
import TwoStar from './Icons/2star.png';
import ThreeStar from './Icons/3star.png';
import FourStar from './Icons/4star.png';
import FiveStar from './Icons/4star.png';
import Critical from './Icons/Critical.png';
import Down from './Icons/Down.png';
import Equal from './Icons/Equal.png';
import FalseBlank from './Icons/FalseBlank.png';
import True from './Icons/True.png';
import TrueGreen from './Icons/TrueGreen.png';
import Up from './Icons/Up.png';
import saveAs from 'file-saver';
import {Workbook} from 'exceljs';
import {exportDataGrid} from 'devextreme/excel_exporter';
import {exportPivotGrid} from 'devextreme/excel_exporter';

// green
// red
// blue
// star
// up_down_equal

export function CellRenderImage(e) {
    if (e.column.hasOwnProperty('ImageDetails')) {
        if (e.column.ImageDetails === 'green') {
            if (e.value) {
                return <img alt="Yes" src={TrueGreen} key={Math.random()}/>;
            } else {
                return <img alt="No" src={FalseBlank} key={Math.random()}/>;
            }
        } else if (e.column.ImageDetails === 'red') {
            if (e.value) {
                return <img alt="Yes" src={Critical} key={Math.random()}/>;
            } else {
                return <img alt="No" src={FalseBlank} key={Math.random()}/>;
            }
        } else if (e.column.ImageDetails === 'blue') {
            if (e.value) {
                return <img alt="Yes" src={True} key={Math.random()}/>;
            } else {
                return <img alt="No" src={FalseBlank} key={Math.random()}/>;
            }
        } else if (e.column.ImageDetails === 'star') {
            switch (e.value) {
                case 0:
                    return <img alt="0" src={FalseBlank} key={Math.random()}/>;
                case 1:
                    return <img alt="1" src={OneStar} key={Math.random()}/>;
                case 2:
                    return <img alt="2" src={TwoStar} key={Math.random()}/>;
                case 3:
                    return <img alt="3" src={ThreeStar} key={Math.random()}/>;
                case 4:
                    return <img alt="4" src={FourStar} key={Math.random()}/>;
                case 5:
                    return <img alt="5" src={FiveStar} key={Math.random()}/>;
                default:
                    return <img alt="ERROR"/>;
            }
        } else if (e.column.ImageDetails === 'up_down_equal') {
            switch (e.value) {
                case 'up':
                    return <img alt="High" src={Up} key={Math.random()}/>;
                case 'down':
                    return <img alt="Low" src={Down} key={Math.random()}/>;
                case 'equal':
                    return <img alt="Equal" src={Equal} key={Math.random()}/>;
                default:
                    return <img alt="ERROR"/>;
            }
        }
    }

    return <div></div>;
}

export function onExcelExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Main sheet');

    let component = e.hasOwnProperty("component") ? e.component : e;

    exportDataGrid({
        component: component,
        worksheet: worksheet,
        autoFilterEnabled: true,
        topLeftCell: {row: 2, column: 2},
        customizeCell: function (options) {
            let {gridCell, excelCell} = options;
            if (gridCell.rowType === 'data') {
                if (excelCell.value && excelCell.value.toString().includes('<br')) {
                    excelCell.alignment = {wrapText: true};
                    excelCell.value = excelCell.value.replaceAll('<br />', '\r\n').replaceAll('<br/>', '\r\n');
                }
            }
        }
    }).then(() => {
        let fileName = component.option('export.fileName');
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], {type: 'application/octet-stream'}), fileName + '.xlsx');
        });
    });
    e.cancel = true;
}

export function onPivotExcelExporting(e) {
    const workbook = new Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');

    exportPivotGrid({
        component: e.component,
        worksheet: worksheet,
    }).then(() => {
        let fileName = e.component.option('exportFileName');
        workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(
                new Blob([buffer], {type: 'application/octet-stream'}),
                fileName,
            );
        });
    });
    e.cancel = true;
}

export function EditorKeyboardNavigationSettings(e) {
    let currentRowIndex = -1, currentColumnIndex = -1;
    let mapKeysToHandlers = {
        'ArrowUp': selectPreviousRow,
        'ArrowDown': selectNexRow,
        'ArrowLeft': selectPreviousColumn,
        'ArrowRight': selectNextColumn
    };

    function shiftRow(shiftCount) {
        let targetRow = currentRowIndex + shiftCount;

        if (targetRow >= 0) {
            let target = e.component.getRowElement(targetRow);
            if (target !== undefined) {
                if (target[0].classList.contains('dx-group-row')) {
                    if (shiftCount < 0)
                        targetRow = targetRow - 1;
                    else
                        targetRow = targetRow + 1;
                }
                if (targetRow >= 0) {
                    let col = e.component.option('columns')[currentColumnIndex];
                    e.component.editCell(targetRow, col['dataField']);
                }

            }
        }
    }

    function shiftColumn(shiftCount) {
        let targetColumn = currentColumnIndex + shiftCount;

        if (targetColumn >= 0) {
            if (targetColumn < e.component.columnCount()) {
                let col = e.component.option('columns')[targetColumn];
                if (col['allowEditing'])
                    e.component.editCell(currentRowIndex, col['dataField']);
            }
        }
    }

    function selectNexRow() {
        shiftRow(1);
    }

    function selectPreviousRow() {
        shiftRow(-1);
    }

    function selectPreviousColumn() {
        shiftColumn(-1);
    }

    function selectNextColumn() {
        shiftColumn(1);
    }

    function applyValuesAndMove(f) {
        currentRowIndex = e.component.getRowIndexByKey(e.row.key);
        currentColumnIndex = e.component.columnOption(e.dataField, 'visibleIndex');

        let findHandler = mapKeysToHandlers[f.event.key];
        if (findHandler) {
            if (e['editorName'] === 'dxSelectBox') {

            } else {
                if (e.value && e.value.toString() !== f.event.target.value) {
                    e.setValue(f.event.target.value);
                    e.component.saveEditData().done(() => {
                        setTimeout(() => {
                            findHandler(e.row.rowIndex);
                        }, 10);
                    });
                } else {
                    findHandler(e.row.rowIndex);
                }
            }
            f.event.preventDefault();
            f.event.stopPropagation();
        }
    }

    e.editorOptions.onKeyDown = function (f) {
        applyValuesAndMove(f);
    };
}